import "../../App.css";
import "./Service.css"

const Service = () =>{

    return(
        <div className="service">
            <div className="container service">
				<section className="sec service-s1 grid">
					<div>
						<h1>Sociálne služby</h1>
						<p>
						Sociálne služby sú odborné činnosti, obslužné činnosti a ďalšie činnosti alebo súbor týchto činností, ktoré sú zamerané na:
						</p>
						<ul>
							<li>prevenciu vzniku nepriaznivej sociálnej situácie, riešenie nepriaznivej sociálnej situácie alebo zmiernenie nepriaznivej sociálnej situácie fyzickej osoby, rodiny alebo komunity,</li>
							<li>zachovanie, obnovu alebo rozvoj schopnosti fyzickej osoby viesť samostatný život a na podporu jej začlenenia do spoločnosti,</li>
							<li>zabezpečenie nevyhnutných podmienok na uspokojenie základných životných potrieb fyzickej osoby,</li>
							<li>riešenie krízovej sociálnej situácie fyzickej osoby a rodiny,</li>
							<li>prevenciu sociálneho vylúčenia fyzickej osoby a rodiny.</li>
						</ul>
					</div>
					<div className="service-s1-img">
						<img src="images/service.png" alt=""/>
					</div>
				</section>
				
				<section className="sec service-s2">
					<h2 className="ta-c">JUSTÍNA, n.o. zariadenie pre seniorov poskytuje</h2>
					<div className="grid grid-3">
						<div className="card">
							<h3>Odborné činnosti:</h3>
							<ul>
								<li>pomoc pri odkázanosti na pomoc inej fyzickej osoby,</li>
								<li>pomoc pri uplatňovaní práv a právom chránených záujmov,</li>
								<li>sociálne poradenstvo,</li>
								<li>ošetrovateľská starostlivosť,</li> 
								<li>pracovná terapia.</li>
							</ul>
						</div>
					
						<div className="card">
							<h3>Obslužné činnosti:</h3>
							<ul>
								<li>ubytovanie,</li>
								<li>upratovanie,</li>
								<li>pranie, žehlenie a údržba bielizne,</li>
								<li>stravovanie.</li> 
							</ul>
						</div>
					
						<div className="card">
						<h3>Ďaľšie činnosti:</h3>
							<ul>
								<li>vykonávanie nevyhnutnej základnej hygieny,</li>
								<li>úschova cenných vecí,</li>
								<li>organizovanie záujmovej činnosti,</li>
								<li>kultúrna činnost a duchovná starostlivosť,</li> 
								<li>osobné vybavenie,</li>
								<li>podpora účasti na spoločenskom živote,</li>
								<li>zabezpečenie prepravy do zdravotníckeho zariadenia,</li>
								<li>zabezpečenie liekov a pomocok v plnej réžii klienta.</li>
							</ul>
						</div>
					</div>
				</section>
				
				<section className="sec service-s3">
					<h3>ZpS JUSTÍNA ďalej zabezpečuje:</h3>
					<ul>
						<li>kadernícke služby,</li>
						<li>manikúra,</li> 
						<li>pedikúra.</li>
					</ul>
				</section>

				<section className="sec service-s4">
					<h3>Sociálna práca</h3>
					<p>
						Sociálna práca je realizovaná prostredníctvom sociálnej rehabilitácie, aktivít, kultúrnych podujatí, krúžkových činností, prebieha podľa vypracovaného ročného plánu, mesačného a týždenného plánu. Po adaptačnom programe klientovi jednotli vypracujeme IP – individuálny plán, ktorých ciele určujeme podľa potreby klienta. Tento sa realizuje pravidelne podľa rozpisových harmonogramov. Zohľadňujeme zdravotný stav klienta, jeho možnosti a schopnosti ako aj právo rozhodnúť sa pre aktivity. V prípade záujmu sa môže zúčastňovať krúžkovej činnosti: výtvarný, hudobný, šikovných rúk a športový. Výsledky výtvarného krúžku a krúžku šikovných rúk zdobia priestory zariadenia. 
					</p>

					<p>
					Klienti sa aktívne zapájajú do činností. Veľmi obľúbené sú vystrihovanie, kreslenie, výroba ozdôb,výroba násteniek a dekorácií. V priebehu roka sme organizovali väčšie spoločenské udalosti: oslavy založenia ZpS, fašiangové popoludnia, vianočný večierok, Mikuláš, súťažné popoludnia spojené s hudbou a spevom a pod. Tieto akcie boli obohatené o kultúrny program, tombolu a pohostenie. Sviatočné chvíle boli spríjemnené prekvapením vo forme Mikulášskych a Vianočných balíčkov.
					</p>
					
					<h3>Zdravotná  starostlivosť</h3>
					<p> Lekárska starostlivosť je zabezpečená v 5 km vzdialenej poliklinike v Leviciach. Klienti sú v starostlivosti obvodných lekárov. Zariadenie pre seniorov zabezpečuje pre klientov starostlivosť prostredníctvom špecialistov – diabetológ, psychiater, neurológ, urológ, očný lekár a pod. Lieky a pomôcky pre klientov zabezpečuje personál ZpS v plnej réžii klienta. V prípade potreby vyšetrenia alebo návštevy špecialistu prepravu zabezpečujeme sanitkou cez obvodného lekára alebo formou červeného kríža. Klientov doprevádza kvalifikovaný personál.
					</p>
					<p>
					Ošetrovateľská starostlivosť je zabezpečená cestou agentúry domácej ošetrovateľskej starostlivosti (ADOS), kde pracujú erudované sestry. Do ošetrovateľskej starostlivosti patrí aj ošetrovateľská rehabilitácia.
					Masáže sú vykonávané kvalifikovaným masérom.
					</p>
				</section>
            </div>
        </div>
    );
}

export default Service;